import { Text } from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";

export function SentRequestError() {
  return (
    <Stack alignItems="center" spacing={7}>
      <Text variant="body1">
        Please try again later or contact our support, if the issue persists.
      </Text>
    </Stack>
  );
}
